import { matchPath } from 'react-router-dom';
import { useCartStore } from '@hungryroot/global-state';
import {
  MY_HUNGRYROOT_ROUTE,
  ORDER_ROUTE,
  EDIT_DELIVERY_RECIPES_FOR_YOU_ROUTE,
  EDIT_DELIVERY_RECIPES_ROUTE,
} from '@hungryroot/routes';
import { getCmsRecipePageNameMappings } from './cmsRecipePageNameMappings';
import { RECIPE_PAGE_NAME_MAPPINGS } from './pageNameMappings';

export const getRecipesPageName = () => {
  const cartState = useCartStore.getState();
  if (cartState.cartActive) {
    return 'cart';
  }

  const url = new URL(window.location.href);
  const pathname = url.pathname;

  if (
    matchPath(pathname, {
      path: EDIT_DELIVERY_RECIPES_FOR_YOU_ROUTE,
      exact: false,
      strict: false,
    })
  ) {
    return 'for_you';
  }

  if (
    matchPath(pathname, {
      path: EDIT_DELIVERY_RECIPES_ROUTE,
      exact: true,
      strict: false,
    }) &&
    url.searchParams.size === 0
  ) {
    return 'all';
  }

  if (
    matchPath(pathname, {
      path: EDIT_DELIVERY_RECIPES_FOR_YOU_ROUTE,
      exact: false,
      strict: false,
    })
  ) {
    return 'all';
  }

  if (
    matchPath(pathname, {
      path: MY_HUNGRYROOT_ROUTE,
      exact: false,
      strict: false,
    })
  ) {
    return 'home';
  }

  if (
    matchPath(pathname, {
      path: ORDER_ROUTE,
      exact: false,
      strict: false,
    })
  ) {
    return 'order_details';
  }

  // Prefer CMS analytics_page_name overrides when present.
  const cmsMatch = Object.entries(getCmsRecipePageNameMappings()).find(
    ([key]) => url.searchParams.has(key)
  );
  if (cmsMatch) {
    return cmsMatch[1];
  }

  const match = Object.entries(RECIPE_PAGE_NAME_MAPPINGS).find(([key]) =>
    url.searchParams.has(key)
  );

  return match?.[1];
};
